module.exports = __webpack_public_path__ + "teqbahn-assets/media/13.55eb76e4.png";